import React from 'react'

import { useModalContext } from '@fourthwall/components'
import { useWebViewBridge } from '@fourthwall/webview-bridge'

import { CreatePromotionModal } from '../../modules/CreatePromotionModal'
import { useFilterPromotionCodes } from './modules/PromotionCodesFilter'
import { PromotionCodesInfinite } from './modules/PromotionCodesInfinite/PromotionCodesInfinite'
import { PromotionCodesList } from './modules/PromotionCodesList/PromotionCodesList'

export const PromotionCodes = () => {
  const { open } = useModalContext()
  const { hasFilterParams } = useFilterPromotionCodes()
  const { isWebView } = useWebViewBridge()

  const getEmptyStateProps = () => {
    if (hasFilterParams) {
      return {
        title: 'No promotions found',
        subtitle: 'Adjust your filters.',
      }
    }

    return {
      title: "You haven't created any promo codes yet.",
      label: 'Create promo code',
      onClick: () => open(CreatePromotionModal),
    }
  }

  const emptyStateProps = getEmptyStateProps()

  if (isWebView) {
    return <PromotionCodesInfinite emptyStateProps={emptyStateProps} />
  }

  return <PromotionCodesList emptyStateProps={emptyStateProps} />
}
